import { render, staticRenderFns } from "./Ocorrencia.vue?vue&type=template&id=9ba13d9c&"
import script from "./Ocorrencia.vue?vue&type=script&lang=js&"
export * from "./Ocorrencia.vue?vue&type=script&lang=js&"
import style0 from "./Ocorrencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports